import { useEffect, useState } from 'react';

export const P2T_ONBOARDING_DONE_KEY = 'p2t_onboarding_done';

/** Synchronous read for route guards (no SSR in this app). */
export function isP2tOnboardingDone(): boolean {
  try {
    const v = localStorage.getItem(P2T_ONBOARDING_DONE_KEY);
    if (v === '1' || v === 'true') return true;
    if (localStorage.getItem('hasVisited') === 'true') {
      localStorage.setItem(P2T_ONBOARDING_DONE_KEY, '1');
      return true;
    }
    return false;
  } catch {
    return false;
  }
}

/**
 * Guest generation counter persistence, first-visit landing overlay, and scroll-to-dismiss behaviour.
 * Onboarding flags (`p2t_onboarding_done`, `hasVisited`) are independent of `app_language`:
 * language is chosen in `useUserSettings` before the user taps “start”.
 */
export function useGuestLandingFlow() {
  const [guestGenerations, setGuestGenerations] = useState(() => {
    const storedGenerations = localStorage.getItem('guestGenerations');
    return storedGenerations ? parseInt(storedGenerations, 10) : 0;
  });
  const [showLandingPage, setShowLandingPage] = useState(() => !isP2tOnboardingDone());

  const handleTryForFreeClick = () => {
    setShowLandingPage(false);
    try {
      localStorage.setItem(P2T_ONBOARDING_DONE_KEY, '1');
    } catch {
      /* ignore */
    }
  };

  useEffect(() => {
    if (!showLandingPage) {
      try {
        localStorage.setItem(P2T_ONBOARDING_DONE_KEY, '1');
      } catch {
        /* ignore */
      }
    }
  }, [showLandingPage]);

  useEffect(() => {
    localStorage.setItem('guestGenerations', guestGenerations.toString());
  }, [guestGenerations]);

  return {
    guestGenerations,
    setGuestGenerations,
    showLandingPage,
    setShowLandingPage,
    handleTryForFreeClick,
  };
}
